import React, { SVGProps } from 'react'

export const NoHeartMonitorIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
    <g fill="#000" fillOpacity={0.56} fillRule="evenodd" clipPath="url(#a)" clipRule="evenodd">
      <path d="M20 24 0 1 1.132.016l20 23L20 24Z" />
      <path d="M20.974 19.922c.209-.073.401-.197.576-.372.3-.3.45-.65.45-1.05v-4.25h-1.5v4.25h-.763l1.237 1.422ZM13.3 11.098 14 9.7l1.325 2.65a.635.635 0 0 0 .281.3c.125.067.257.1.394.1h6v-1.5h-5.525l-1.8-3.575a.554.554 0 0 0-.28-.29.963.963 0 0 0-.786 0 .56.56 0 0 0-.284.29l-1.098 2.188 1.074 1.235Zm-2.044.697 1.076 1.238-1.658 3.317a.639.639 0 0 1-.285.3.815.815 0 0 1-.786 0 .634.634 0 0 1-.279-.3l-1.8-3.6H2v-1.5h6c.137 0 .269.033.394.1a.635.635 0 0 1 .281.3L10 14.3l1.257-2.505ZM8.433 5.5H20.5v4.25H22V5.5c0-.4-.15-.75-.45-1.05-.3-.3-.65-.45-1.05-.45H7.129l1.304 1.5ZM4.478 4l1.305 1.5H3.5v4.25H2V5.5c0-.4.15-.75.45-1.05.3-.3.65-.45 1.05-.45h.978Zm12.609 14.5 1.304 1.5H3.5c-.4 0-.75-.15-1.05-.45-.3-.3-.45-.65-.45-1.05v-4.25h1.5v4.25h13.587Z" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
)
